import * as React from 'react';
import ToolNavMarkReview from '../tool/nav/ToolNavMarkReview';
import { IDocument, IExtraction } from '../../types/my-types';
import { AppContext } from '../../App';
import { getIdFromUrl } from '../../utils/getIdFromUrl';
import { MarkStateContext } from '../../context/MarkContext';
import { ToolActionsContextProvider } from '../../context/ToolActionsContext';
import useGlynt from '../hooks/useGlynt';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';
export interface ReviewNavProps {
  steps: number;
  documents: IDocument[];
  docId?: string;
  extractions: IExtraction[];
  extractionIndex: number;
  extractionId?: string;
  batchLabel: string;
  resultsType: import('../../types/spreadsheet-types').IResultsType;
  setResultsType: (t: import('../../types/spreadsheet-types').IResultsType) => void;
  isFullscreen?: boolean;
  setIsFullscreen?: (v: boolean) => void;
}

const ReviewNav: React.FC<ReviewNavProps> = ({
  steps,
  extractions,
  docId,
  documents,
  batchLabel,
  extractionIndex,
  extractionId,
  resultsType,
  setResultsType,
  isFullscreen,
  setIsFullscreen,
}) => {
  const { dpid, id: eid } = useParams<{ dpid: string; id: string }>();
  const { docLabel, tokenizerVersion } = React.useContext(MarkStateContext);

  const { dataPoolId } = React.useContext(AppContext);

  const glynt = useGlynt();
  const client = useQueryClient();
  const generatePage = useMutation({
    mutationFn: async (docId: string) =>
      (await glynt).document.createPages(docId)
  });

  const prefetchPage = () => {
    const extraction = extractions[(extractionIndex % 100) + 2];
    // prefetch pages for doc and tokenized
    if (extraction) {
      const tokenizedId = getIdFromUrl(extraction.tokenized);
      const docId = getIdFromUrl(extraction.document);
      if (tokenizedId.length > 0) {
        client.prefetchQuery({
          queryKey: ['tokenized', tokenizedId],
          queryFn: async () => (await glynt).tokenizeds.retrieve(tokenizedId),
        });
      }
      generatePage.mutate(docId);
    }
  };

  return (
    <ToolActionsContextProvider>
      <ToolNavMarkReview
        batchLabel={batchLabel}
        docLabel={docLabel}
        steps={steps}
        docId={docId}
        docs={documents}
        docIndex={extractionIndex}
        prefetchPage={prefetchPage}
        tokenizerVersion={tokenizerVersion}
        review={true}
        extractionId={extractionId}
        extractions={extractions}
        resultsType={resultsType}
        setResultsType={setResultsType}
        isFullscreen={isFullscreen}
        setIsFullscreen={setIsFullscreen}
      />
    </ToolActionsContextProvider>
  );
};

export default ReviewNav;
